import React from 'react';

export function GroupByControls({ tableState }) {
    if (!tableState.groupByConfig || tableState.groupByConfig.length === 0) return null;

    return (
        <div className="flex items-center gap-1 text-sm bg-slate-800 p-1 rounded-md border border-slate-700 flex-wrap shadow-inner ml-2">
            {tableState.groupByConfig.map((groupCol, idx) => (
                <React.Fragment key={`grp-${groupCol}`}>
                    <span className="material-symbols-outlined text-slate-600 text-[18px]">chevron_right</span>
                    <div 
                        draggable
                        onDragStart={(e) => e.dataTransfer.setData('sapphire/group-idx', idx)}
                        onDragOver={(e) => e.preventDefault()}
                        onDrop={(e) => {
                            const fromIdx = parseInt(e.dataTransfer.getData('sapphire/group-idx'));
                            if (!isNaN(fromIdx) && fromIdx !== idx) {
                                tableState.moveGroup(fromIdx, idx);
                            }
                        }}
                        className="flex items-center gap-1 bg-blue-900/40 text-blue-200 px-2 py-1 rounded cursor-grab hover:bg-blue-800/50 border border-blue-800/50 transition-colors"
                        title="Drag to reorder"
                    >
                        <span className="material-symbols-outlined text-[14px] opacity-70">layers</span>
                        {groupCol}
                        <button onClick={() => tableState.removeGroup(groupCol)} className="hover:text-red-400 ml-1 text-[14px]">
                            <span className="material-symbols-outlined text-[14px]">close</span>
                        </button>
                    </div>
                </React.Fragment>
            ))}
        </div>
    );
}
